<ng-container *ngIf="!contract.HasDirectDebit">
    <edp-widget-payment [contractSelected]="contract" [balance]="balanceObject" [isDebt]="false" [dateLimit]="dateLimit" [totalDebtInvoices]="totalDebtInvoices" [paymentData]="paymentData"></edp-widget-payment>
</ng-container>
<ng-container *ngIf="contract.HasDirectDebit">
    <edp-widget-payment-direct-debit [contractSelected]="contract" [balance]="balanceObject" [dateLimit]="dateLimit"></edp-widget-payment-direct-debit>
</ng-container>
